import { call, put, takeEvery } from 'redux-saga/effects';
import { notificationActions } from '../../notifications/actions/notification';
import * as telephonyActions from '../actions/telephony';
import * as api from '../api/telephony';
const { notificationAdd } = notificationActions;
// Destructure the telephony actions.
const { telephonyGetAllNumbers, telephonyGetAllNumbersSucceeded, telephonyGetAllNumbersFailed, telephonyGetNumbersByQuery, telephonyGetNumbersByQuerySucceeded, telephonyGetNumbersByQueryFailed, telephonyReleaseNumber, telephonyReleaseNumberSucceeded, telephonyReleaseNumberFailed, telephonyUpdateNumber, telephonyUpdateNumberSucceeded, telephonyUpdateNumberFailed, telephonyBuyNumber, telephonyBuyNumberSucceeded, telephonyBuyNumberFailed, telephonyBuyGroupNumberDelivered, telephonyBuyGroup, telephonyBuyGroupSucceeded, telephonyBuyGroupFailed, telephonyVerifyExternalCallerId, telephonyVerifyExternalCallerIdSucceeded, telephonyVerifyExternalCallerIdFailed, telephonySearchNumbers, telephonySearchNumbersSucceeded, telephonySearchNumbersFailed, telephonySearchNumbersByNumType, telephonySearchNumbersByNumTypeSucceeded, telephonySearchNumbersByNumTypeFailed, } = telephonyActions.actions;
export const telephony = [
    takeEvery(telephonyGetAllNumbers.toString(), genWithPromise(api.getAllNumbers, telephonyGetAllNumbersSucceeded, telephonyGetAllNumbersFailed)),
    takeEvery(telephonyGetNumbersByQuery.toString(), genWithPromise(api.getNumbersByQuery, telephonyGetNumbersByQuerySucceeded, telephonyGetNumbersByQueryFailed)),
    takeEvery(telephonyReleaseNumber.toString(), genWithPromiseRelease(api.releaseNumber, telephonyReleaseNumberSucceeded, telephonyReleaseNumberFailed)),
    takeEvery(telephonyUpdateNumber.toString(), genWithPromise(api.updateNumber, telephonyUpdateNumberSucceeded, telephonyUpdateNumberFailed)),
    takeEvery(telephonyBuyNumber.toString(), genWithPromise(api.buyNumber, telephonyBuyNumberSucceeded, telephonyBuyNumberFailed)),
    takeEvery(telephonyBuyGroup.toString(), genWithPromiseBuyGroup(api.buyGroup, telephonyBuyGroupSucceeded, telephonyBuyGroupFailed)),
    takeEvery(telephonyBuyGroupNumberDelivered.toString(), notifyGroupNumberDelivered),
    takeEvery(telephonyVerifyExternalCallerId.toString(), genWithPromiseExternal(api.verifyExternalCallerId, telephonyVerifyExternalCallerIdSucceeded, telephonyVerifyExternalCallerIdFailed)),
    takeEvery(telephonySearchNumbers.toString(), genWithPromise(api.searchNumbers, telephonySearchNumbersSucceeded, telephonySearchNumbersFailed)),
    takeEvery(telephonySearchNumbersByNumType.toString(), genWithPromise(api.searchNumbers, telephonySearchNumbersByNumTypeSucceeded, telephonySearchNumbersByNumTypeFailed)),
];
function genWithPromise(apiAction, resultSucceededAction, resultFailedAction) {
    return function* (action) {
        let result;
        try {
            result = yield call(apiAction, action.payload);
            yield call(action.meta.resolve, result);
            yield put(resultSucceededAction(result));
        }
        catch (exception) {
            console.warn(exception);
            // Something went wrong. We reject the promise.
            yield call(action.meta.reject, exception);
            yield put(resultFailedAction(exception));
        }
    };
}
function genWithPromiseExternal(apiAction, resultSucceededAction, resultFailedAction) {
    return function* (action) {
        let result;
        const option = {
            title: `Could not verify number`,
            text: `"${action.payload.phone_number}" could not be verified as external caller id.`,
            className: 'warning',
            icon: 'i-exclamation',
            time: 10000,
        };
        try {
            result = yield call(apiAction, action.payload);
            yield call(action.meta.resolve, result);
            yield put(resultSucceededAction(result));
        }
        catch (exception) {
            console.warn(exception);
            // Something went wrong. We reject the promise.
            yield call(action.meta.reject, exception);
            yield put(resultFailedAction(exception));
            yield put(notificationAdd(option));
        }
    };
}
function genWithPromiseBuyGroup(apiAction, resultSucceededAction, resultFailedAction) {
    return function* (action) {
        let result;
        const option = {
            title: 'New number ordered',
            text: `You will receive your new number within 5 minutes.`,
            className: 'success',
            type: 'newGroupPurchased',
            icon: 'i-done',
            time: 10000,
        };
        try {
            result = yield call(apiAction, action.payload);
            yield call(action.meta.resolve, result);
            yield put(resultSucceededAction(result));
            yield put(notificationAdd(option));
        }
        catch (exception) {
            console.warn(exception);
            // Something went wrong. We reject the promise.
            yield call(action.meta.reject, exception);
            yield put(resultFailedAction(exception));
        }
    };
}
function genWithPromiseRelease(apiAction, resultSucceededAction, resultFailedAction) {
    return function* (action) {
        let result;
        const option = {
            title: 'Number released',
            text: `The number ${action.payload.e164_format} was released`,
            className: 'success',
            type: 'numberReleased',
            icon: 'i-done',
            time: 10000,
        };
        try {
            result = yield call(apiAction, action.payload);
            yield call(action.meta.resolve, result);
            yield put(resultSucceededAction(result));
            yield put(notificationAdd(option));
        }
        catch (exception) {
            console.warn(exception);
            // Something went wrong. We reject the promise.
            yield call(action.meta.reject, exception);
            yield put(resultFailedAction(exception));
        }
    };
}
function* notifyGroupNumberDelivered(action) {
    let incoming = '';
    let outgoing = '';
    const option = {
        title: `${action.payload.result.data.e164_format} is ready`,
        text: '',
        className: 'success',
        type: 'newGroupDelivered',
        icon: 'i-done',
        time: 10000,
    };
    if (action.payload.result.status !== undefined &&
        action.payload.result.status === 'incoming_functionality') {
        option.title + ' for incoming calls.';
        incoming = 'You can now receive incoming calls.';
        option.text = `${incoming} ${outgoing}`;
        yield put(notificationAdd(option));
    }
    if (action.payload.result.status !== undefined &&
        action.payload.result.status === 'outgoing_verified') {
        option.title + ' for outgoing calls.';
        outgoing = 'You can now make outgoing calls.';
        option.text = `${incoming} ${outgoing}`;
        yield put(notificationAdd(option));
    }
}
